import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DmarcAuthTable from '../../components/domain-progress/dmarc-auth-table';

import { exportToCSVFailure, exportToCSVSuccess } from '../../actions/export-report-action-creators';
import { authTableIsExportingGridToCSV, flattenedDmarcAuthSelector } from '../../selectors/dmarc-auth-selectors';
import { selectedIntervalSelector } from '../../selectors/reports-selectors';

export class DmarcAuthTableContainer extends Component{
    render(){
        const {
            flattenedDmarcAuthData, interval, isExportingGridToCSV, exportToCSVSuccess, exportToCSVFailure
        } = this.props;
        return (
            <DmarcAuthTable
                interval={interval}
                data={flattenedDmarcAuthData}
                isExportingGridToCSV={isExportingGridToCSV}
                exportToCSVSuccess={exportToCSVSuccess}
                exportToCSVFailure={exportToCSVFailure}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        flattenedDmarcAuthData: flattenedDmarcAuthSelector( state ),
        interval: selectedIntervalSelector( state ),
        isExportingGridToCSV: authTableIsExportingGridToCSV( state )
    };
};

DmarcAuthTableContainer.propTypes = {
    exportToCSVFailure: PropTypes.func,
    exportToCSVSuccess: PropTypes.func,
    flattenedDmarcAuthData: PropTypes.array.isRequired,
    interval: PropTypes.string.isRequired,
    isExportingGridToCSV: PropTypes.bool,
};

export default connect(
    mapStateToProps, { exportToCSVFailure, exportToCSVSuccess }
)( DmarcAuthTableContainer );
